import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from '../SortContainer';
import { searchConstants } from '../../../search-utils/searchConstants';
import { SortItem } from './SortItem';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { SortTypes } from '../../../search.types';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';

type Props = PropsFromRedux & WithRestrictedModalProps & UserContextType;

export class RawSortList extends React.Component<Props> {
  changeSortClicked = (type: SortTypes) => () => {
    const { accessPremium, onSortUpdate, openRestrictedModal } = this.props;
    if (!accessPremium) {
      openRestrictedModal(searchConstants.sorts[type].event);
    } else {
      doctrineAnalytics('Search FilterSortClicked', { sort: type });
      onSortUpdate(type);
    }
  };

  render() {
    const { selectedSort, displayCommentariesSearch } = this.props;
    return (
      <div className="search-filter search-filters-sort-list">
        <div className="search_facet__title">
          <FormattedMessage id="search/components/search-sort/sort-list/SortList.tsx/1" />
        </div>
        <SortItem
          isSelected={selectedSort === 'relevance'}
          type="relevance"
          handleClick={this.changeSortClicked}
        />
        <SortItem
          isSelected={selectedSort === 'chrono'}
          type="chrono"
          handleClick={this.changeSortClicked}
        />
        <SortItem
          isSelected={selectedSort === 'antiChrono'}
          type="antiChrono"
          handleClick={this.changeSortClicked}
        />
        {displayCommentariesSearch && (
          <SortItem
            isSelected={selectedSort === 'commented'}
            type="commented"
            handleClick={this.changeSortClicked}
          />
        )}
      </div>
    );
  }
}

export const SortList = withUser(withRestrictedModal(Connect(RawSortList)));
